import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseCreateDto } from '../../base/baseCreate.dto'

@ArgsType()
export class CreateMessageThreadDto extends BaseCreateDto<CreateMessageThreadDto> {
  @Field(t => Int)
  arcId!: number

  @Field(t => Int)
  reviewUserId!: number
}
